import { UserInfo } from './types'

export const getUserInfo = async (): Promise<UserInfo> => {
  const userInfo = sessionStorage.getItem('userInfo') ?? '{}'

  return JSON.parse(userInfo)
}
